module.exports = __webpack_public_path__ + "img/color-dynamics-2_jp.8b6e845.jpg";